import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from './hooks/useAuth';
import useRefreshToken from './hooks/useRefreshToken';
import useLocalStorage from './hooks/useLocalStorage';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Suspense, lazy } from "react";

import RoleRedirect from './layouts/RoleRedirect';

import PageNotFound from './pages/PageNotFound';
import Login from './pages/Login/Login';

import ProgressBar from './components/ui/ProgressBar';

const AdminLayout = lazy(() => import("./layouts/AdminLayout"));
const CashierLayout = lazy(() => import("./layouts/CashierLayout"));

function App() {
  const { t } = useTranslation();
  const { auth, ready } = useAuth();
  const refresh = useRefreshToken();
  const l = useLocalStorage(); // Hook automatically runs when ready

  useEffect(() => {
    refresh();
    if (auth?.token && ready) l();
  }, [auth?.token]);
  
  if (!auth?.token && !ready) {
    return <div className='d-flex flex-column align-items-center justify-content-between medium py-5'>{t('LOADING')}...</div>; // block routing until ready
  }
  
  return (
    <BrowserRouter>
      <RoleRedirect>
        <Suspense fallback={<ProgressBar />}>
          <Routes>
            {/* public routes */}
            <Route path='/auth/signin' element={<Login />} />
            <Route path='/page-not-found' element={<PageNotFound />} />

            <Route path="/*" element={<AdminLayout />}/>
            <Route path='/cp/*' element={<CashierLayout />}/>
          </Routes>
        </Suspense>
      </RoleRedirect>
    </BrowserRouter>
  );
}

export default App;